export default __webpack_public_path__ + "static/media/fillerimg.c3b0b3a6.jpeg";